import {usePortalTooltip} from '@github-ui/portal-tooltip/use-portal-tooltip'
import type {LabelProps} from '@primer/react'
import {Label} from '@primer/styled-react'
import React from 'react'

type Props = LabelProps & {
  label: string
  ariaLabel: string
  className?: string
  testId: string
  viewerDidAuthor?: boolean
  leadingElement?: React.ReactNode
}

export const CommentHeaderBadge: React.FC<Props> = ({
  label,
  ariaLabel,
  testId,
  viewerDidAuthor,
  variant,
  leadingElement,
  className,
}: Props) => {
  const contentRef = React.useRef<HTMLDivElement>(null)
  const [buttonContentProps, buttonTooltipElement] = usePortalTooltip({
    contentRef,
    'aria-label': ariaLabel,
  })
  return (
    <Label
      variant={variant || 'secondary'}
      data-testid={testId}
      aria-label={ariaLabel}
      className={className}
      ref={contentRef}
      sx={viewerDidAuthor ? {borderColor: 'accent.muted'} : {}}
      {...buttonContentProps}
    >
      {leadingElement}
      {label}
      {buttonTooltipElement}
    </Label>
  )
}

try{ CommentHeaderBadge.displayName ||= 'CommentHeaderBadge' } catch {}